import React from 'react';

const Contact = () => {
  return (
    <div>
      <h2>Contact</h2>
      <a
        className="button"
        href="https://www.linkedin.com/company/scale-angels/"
        target="_blank"
        rel="noreferrer"
      >
        Follow us on LinkedIn
      </a>
    </div>
  );
};

export default Contact;
